import { create } from "zustand";
import type { UserFlowType } from "../types/types";

/**
 * ScannerStore contains scanner configuration used when redirecting to the
 * standalone scanner. It should not be persisted between sessions since it
 * needs to change if the current product changes.
 */
interface ScannerStore {
  flowType?: UserFlowType;
  disableCaptureValidation: boolean;
  setFlowType: (ft: UserFlowType) => void;
  setDisableCaptureValidation: (vc: boolean) => void;
}

export const useScannerStore = create<ScannerStore>((set) => ({
  flowType: undefined,
  disableCaptureValidation: false,
  setFlowType: (by) => {
    set(() => ({ flowType: by }));
  },
  setDisableCaptureValidation: (by) => {
    set(() => ({ disableCaptureValidation: by }));
  },
}));
